webpackJsonp([151346855660394],{

/***/ 25:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	// Handle legacy names for image queries.
	var convertProps = function convertProps(props) {
	  var convertedProps = _extends({}, props);
	
	  if (convertedProps.responsiveSizes) {
	    convertedProps.sizes = convertedProps.responsiveSizes;
	    delete convertedProps.responsiveSizes;
	  }
	
	  // Use own string for sizes attribute
	  convertedProps.sizes.sizes = props.sizesString;
	
	  return convertedProps;
	};
	
	// Cache if we've seen an image before so we don't both with
	// lazy-loading & fading in on subsequent mounts.
	var imageCache = {};
	var inImageCache = function inImageCache(props) {
	  var convertedProps = convertProps(props);
	  // Find src
	  var src = convertedProps.sizes.src;
	
	  if (imageCache[src]) {
	    return true;
	  } else {
	    imageCache[src] = true;
	    return false;
	  }
	};
	
	var io = void 0;
	var listeners = [];
	
	function getIO() {
	  if (typeof io === "undefined" && typeof window !== "undefined" && window.IntersectionObserver) {
	    io = new window.IntersectionObserver(function (entries) {
	      entries.forEach(function (entry) {
	        listeners.forEach(function (l) {
	          if (l[0] === entry.target) {
	            // Edge doesn't currently support isIntersecting, so also test for an intersectionRatio > 0
	            if (entry.isIntersecting || entry.intersectionRatio > 0) {
	              io.unobserve(l[0]);
	              l[1]();
	            }
	          }
	        });
	      });
	    }, { rootMargin: "10px" });
	  }
	
	  return io;
	}
	
	var listenToIntersections = function listenToIntersections(el, cb) {
	  getIO().observe(el);
	  listeners.push([el, cb]);
	};
	
	var isWebpSupportedCache = null;
	var isWebpSupported = function isWebpSupported() {
	  if (isWebpSupportedCache !== null) {
	    return isWebpSupportedCache;
	  }
	
	  var elem = typeof window !== "undefined" ? window.document.createElement("canvas") : {};
	  if (elem.getContext && elem.getContext("2d")) {
	    isWebpSupportedCache = elem.toDataURL("image/webp").indexOf("data:image/webp") === 0;
	  } else {
	    isWebpSupportedCache = false;
	  }
	
	  return isWebpSupportedCache;
	};
	
	var noscriptImg = function noscriptImg(props) {
	  var _props$opacity = props.opacity,
	      opacity = _props$opacity === undefined ? "" : _props$opacity,
	      src = props.src,
	      srcSet = props.srcSet,
	      _props$sizes = props.sizes,
	      sizes = _props$sizes === undefined ? "" : _props$sizes,
	      _props$title = props.title,
	      title = _props$title === undefined ? "" : _props$title,
	      _props$alt = props.alt,
	      alt = _props$alt === undefined ? "" : _props$alt,
	      _props$width = props.width,
	      width = _props$width === undefined ? "" : _props$width,
	      _props$height = props.height,
	      height = _props$height === undefined ? "" : _props$height,
	      _props$transitionDela = props.transitionDelay,
	      transitionDelay = _props$transitionDela === undefined ? "" : _props$transitionDela;
	
	  return "<img width=" + width + " height=" + height + " src=\"" + src + "\" srcset=\"" + srcSet + "\" alt=\"" + alt + "\" title=\"" + title + "\" sizes=\"" + sizes + "\" style=\"position:absolute;top:0;left:0;transition:opacity 0.5s;transition-delay:" + transitionDelay + ";opacity:" + opacity + ";width:100%;height:100%;object-fit:cover;objectPosition:center\"/>";
	};
	
	var Img = function Img(props) {
	  var opacity = props.opacity,
	      onLoad = props.onLoad,
	      _props$transitionDela2 = props.transitionDelay,
	      transitionDelay = _props$transitionDela2 === undefined ? "" : _props$transitionDela2,
	      otherProps = _objectWithoutProperties(props, ["opacity", "onLoad", "transitionDelay"]);
	
	  return _react2.default.createElement("img", _extends({}, otherProps, {
	    onLoad: onLoad,
	    style: {
	      position: "absolute",
	      top: 0,
	      left: 0,
	      transition: "opacity 0.5s",
	      transitionDelay: transitionDelay,
	      opacity: opacity,
	      width: "100%",
	      height: "100%",
	      objectFit: "cover",
	      objectPosition: "center"
	    }
	  }));
	};
	
	Img.propTypes = {
	  opacity: _propTypes2.default.number,
	  transitionDelay: _propTypes2.default.string,
	  onLoad: _propTypes2.default.func
	};
	
	var Image = function (_React$Component) {
	  _inherits(Image, _React$Component);
	
	  function Image(props) {
	    _classCallCheck(this, Image);
	
	    // If this browser doesn't support the IntersectionObserver API
	    // we default to start downloading the image right away.
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    var isVisible = true;
	    var imgLoaded = true;
	    var IOSupported = false;
	
	    // If this image has already been loaded before then we can assume it's
	    // already in the browser cache so it's cheap to just show directly.
	    var seenBefore = inImageCache(props);
	
	    if (!seenBefore && typeof window !== "undefined" && window.IntersectionObserver) {
	      isVisible = false;
	      imgLoaded = false;
	      IOSupported = true;
	    }
	
	    // Always don't render image while server rendering
	    if (typeof window === "undefined") {
	      isVisible = false;
	      imgLoaded = false;
	    }
	
	    _this.state = {
	      isVisible: isVisible,
	      imgLoaded: imgLoaded,
	      IOSupported: IOSupported
	    };
	
	    _this.handleRef = _this.handleRef.bind(_this);
	    return _this;
	  }
	
	  Image.prototype.handleRef = function handleRef(ref) {
	    var _this2 = this;
	
	    if (this.state.IOSupported && ref) {
	      listenToIntersections(ref, function () {
	        _this2.setState({ isVisible: true, imgLoaded: false });
	      });
	    }
	  };
	
	  Image.prototype.render = function render() {
	    var _this3 = this;
	
	    var _convertProps = convertProps(this.props),
	        title = _convertProps.title,
	        alt = _convertProps.alt,
	        className = _convertProps.className,
	        outerWrapperClassName = _convertProps.outerWrapperClassName,
	        _convertProps$style = _convertProps.style,
	        style = _convertProps$style === undefined ? {} : _convertProps$style,
	        sizes = _convertProps.sizes,
	        backgroundColor = _convertProps.backgroundColor;
	
	    var bgColor = void 0;
	    if (typeof backgroundColor === "boolean") {
	      bgColor = "lightgray";
	    } else {
	      bgColor = backgroundColor;
	    }
	
	    if (sizes) {
	      var image = sizes;
	
	      // Use webp by default if browser supports it
	      if (image.srcWebp && image.srcSetWebp && isWebpSupported()) {
	        image.src = image.srcWebp;
	        image.srcSet = image.srcSetWebp;
	      }
	
	      // The outer div is necessary to reset the z-index to 0.
	      return _react2.default.createElement(
	        "div",
	        {
	          className: (outerWrapperClassName ? outerWrapperClassName : "") + " gatsby-image-outer-wrapper",
	          style: {
	            zIndex: 0,
	            // Let users set component to be absolutely positioned.
	            position: style.position === "absolute" ? "initial" : "relative"
	          }
	        },
	        _react2.default.createElement(
	          "div",
	          {
	            className: (className ? className : "") + " gatsby-image-wrapper",
	            style: _extends({
	              position: "relative",
	              overflow: "hidden",
	              zIndex: 1
	            }, style),
	            ref: this.handleRef
	          },
	          _react2.default.createElement("div", {
	            style: {
	              width: "100%",
	              paddingBottom: 100 / image.aspectRatio + "%"
	            }
	          }),
	          image.base64 && _react2.default.createElement(Img, {
	            alt: alt,
	            title: title,
	            src: image.base64
	            // opacity={!this.state.imgLoaded ? 1 : 0}
	            , opacity: 1,
	            transitionDelay: "0.25s"
	          }),
	          bgColor && _react2.default.createElement("div", {
	            title: title,
	            style: {
	              backgroundColor: bgColor,
	              position: "absolute",
	              top: 0,
	              bottom: 0,
	              opacity: !this.state.imgLoaded ? 1 : 0,
	              transitionDelay: "0.35s",
	              right: 0,
	              left: 0
	            }
	          }),
	          this.state.isVisible && _react2.default.createElement(Img, {
	            alt: alt,
	            title: title,
	            srcSet: image.srcSet,
	            src: image.src,
	            sizes: image.sizes,
	            opacity: this.state.imgLoaded || this.props.fadeIn === false ? 1 : 0,
	            onLoad: function onLoad() {
	              requestAnimationFrame(function () {
	                // Make loading a little smoother
	                setTimeout(function () {
	                  _this3.state.IOSupported && _this3.setState({ imgLoaded: true });
	                  _this3.props.onLoad && _this3.props.onLoad();
	                }, 100);
	              });
	            }
	          }),
	          _react2.default.createElement("noscript", {
	            dangerouslySetInnerHTML: {
	              __html: noscriptImg(_extends({ alt: alt, title: title }, image))
	            }
	          })
	        )
	      );
	    }
	
	    return null;
	  };
	
	  return Image;
	}(_react2.default.Component);
	
	Image.defaultProps = {
	  fadeIn: true,
	  alt: ""
	};
	
	Image.propTypes = {
	  responsiveSizes: _propTypes2.default.object,
	  sizes: _propTypes2.default.object,
	  sizesString: _propTypes2.default.string,
	  fadeIn: _propTypes2.default.bool,
	  title: _propTypes2.default.string,
	  alt: _propTypes2.default.string,
	  className: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]), // Support Glamor's css prop.
	  outerWrapperClassName: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),
	  style: _propTypes2.default.object,
	  position: _propTypes2.default.string,
	  backgroundColor: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.bool]),
	  onLoad: _propTypes2.default.func
	};
	
	exports.default = Image;
	module.exports = exports["default"];

/***/ }),

/***/ 72:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _gatsbyLink = __webpack_require__(37);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _Image = __webpack_require__(25);
	
	var _Image2 = _interopRequireDefault(_Image);
	
	var _SizePicker = __webpack_require__(56);
	
	var _SizePicker2 = _interopRequireDefault(_SizePicker);
	
	var _helpers = __webpack_require__(57);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ProductCard = function ProductCard(props) {
	  return _react2.default.createElement(
	    _gatsbyLink2.default,
	    { to: "/product/", className: "hide-child dim-sibling cf" },
	    _react2.default.createElement(
	      "div",
	      { className: "child absolute z-1 absolute--fill bg-white-60 flex flex flex-column items-center align-center justify-center pa4 tc" },
	      props.size === 3 && _react2.default.createElement(
	        "div",
	        { className: "mb3" },
	        _react2.default.createElement(
	          "h3",
	          { className: "f3 f1-l b lh-title mb1" },
	          props.title
	        ),
	        _react2.default.createElement(
	          "span",
	          { className: "f3 f1-l" },
	          props.price,
	          "\xA0\u20AC"
	        )
	      ),
	      props.size !== 3 && _react2.default.createElement(
	        "div",
	        { className: "mb2" },
	        _react2.default.createElement(
	          "h3",
	          { className: "f3 f2-xl b lh-title mb1" },
	          props.title
	        ),
	        _react2.default.createElement(
	          "span",
	          { className: "f3 f2-xl" },
	          props.price,
	          "\xA0\u20AC"
	        )
	      ),
	      _react2.default.createElement(_SizePicker2.default, null)
	    ),
	    _react2.default.createElement(_Image2.default, { className: "v-mid w-100 sibling", sizes: props.image.sizes, sizesString: (0, _helpers.getSizesString)(props.size), alt: props.title })
	  );
	};
	
	ProductCard.propTypes = {
	  size: _propTypes2.default.number.isRequired,
	  title: _propTypes2.default.string.isRequired,
	  price: _propTypes2.default.number.isRequired,
	  image: _propTypes2.default.object.isRequired
	};
	
	exports.default = ProductCard;
	module.exports = exports["default"];

/***/ }),

/***/ 56:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var sizes = [38, 39, 40, 41, 42, 43, 44, 45];
	
	var SizePicker = function (_Component) {
	  _inherits(SizePicker, _Component);
	
	  function SizePicker() {
	    _classCallCheck(this, SizePicker);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  SizePicker.prototype.render = function render() {
	    return _react2.default.createElement(
	      "ul",
	      { className: "list available-sizes cf" },
	      sizes.map(function (size) {
	        return _react2.default.createElement(
	          "li",
	          { className: "fl mr2", key: size },
	          _react2.default.createElement(
	            "button",
	            {
	              className: "f6 outline-0 bg-transparent hover-bg-dark-green hover-white hover-b--dark-green light-silver ba b--light-silver pa1 br2 pointer"
	            },
	            size
	          )
	        );
	      })
	    );
	  };
	
	  return SizePicker;
	}(_react.Component);
	
	exports.default = SizePicker;
	module.exports = exports["default"];

/***/ }),

/***/ 19:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Spacer = function Spacer() {
	  return _react2.default.createElement(
	    "div",
	    { className: "pa3 cf z-1 relative w-100" },
	    "\xA0"
	  );
	};
	
	exports.default = Spacer;
	module.exports = exports["default"];

/***/ }),

/***/ 57:
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	var getSizesString = exports.getSizesString = function getSizesString(size) {
	  switch (size) {
	    case 3:
	      return "(min-width: 60em) 67vw, 100vw";
	    case 2:
	    case 1:
	    default:
	      return "(min-width: 60em) 34vw, 100vw";
	  }
	};

/***/ }),

/***/ 214:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Spacer = __webpack_require__(19);
	
	var _Spacer2 = _interopRequireDefault(_Spacer);
	
	var _ProductCard = __webpack_require__(72);
	
	var _ProductCard2 = _interopRequireDefault(_ProductCard);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CollectionPage = function CollectionPage(_ref) {
	  var data = _ref.data;
	  return _react2.default.createElement(
	    "main",
	    { className: "relative z-1 cf bg-black-10" },
	    _react2.default.createElement(_Spacer2.default, null),
	    _react2.default.createElement(
	      "ul",
	      { className: "list ma0 pa0 grid-ns grid-2-columns-ns grid-3-columns-l" },
	      data.allCollectionJson.edges.map(function (_ref2) {
	        var node = _ref2.node;
	        return _react2.default.createElement(
	          "li",
	          {
	            key: node.id,
	            className: node.size === 1 ? "relative" : node.size === 2 ? "grid-span-2-rows relative" : "grid-span-2-rows grid-span-2-columns relative",
	            "data-scroll": true
	          },
	          _react2.default.createElement(_ProductCard2.default, {
	            size: node.size,
	            title: node.title,
	            price: node.price,
	            image: node.image.childImageSharp
	          })
	        );
	      })
	    )
	  );
	};
	
	CollectionPage.propTypes = {
	  data: _propTypes2.default.objectOf(_propTypes2.default.object).isRequired
	};
	
	exports.default = CollectionPage;
	var query = exports.query = "** extracted graphql fragment **";

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-collection-js-20a089a4ecc4ebfdd1aa.js